export { TextArea } from '../src/TextArea';
